import moment from 'moment'

var formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
})

export const dateStringSorter = (left, right) => {
  return moment(left).diff(moment(right))
}

export const stringSorter = (left, right) => {
  return ('' + left).localeCompare(right)
}

export const statusClasses = (status) => {
  return {
    'font-size-12': true,
    badge: true,
    'badge-primary': status == 'live',
    'badge-success': status == 'completed',
    'badge-default': status == 'announced',
    'badge-default': status == 'closed',
    'badge-danger': status == 'canceled',
  }
}

export const formatMoney = (value) => {
  return formatter.format(value)
}

const _strings = {
  me: {
    english_translation: 'me_translation',
    'Aggregated curve': 'Agregirana kriva',
    'Data chart': 'Grafici podataka',
    'Data table': 'Tabele podataka',
    'Delivery date': 'Datum isporuke',
    'Auction status': 'Status aukcije',
    'Market status': 'Status tržišta',
    'Order Book Closure CET': 'Zatvaranje aukcije CET',
    'Market Result Publication': 'Publikacija rezultata',
    Comments: 'Komentari',
    'Data is not available yet for delivery date':
      'Podaci nisu još uvijek dostupni za datum',
    'Market message': 'Poruka',
    'Base price': 'Bazna cijena',
    'Peak price': 'Vršna cijena',
    'Daily volume': 'Dnevna količina',
    'Monthly volume': 'Mjesečna količina',
    'More details': 'Više detalja',
    'Day ahead market': 'Dan unaprijed tržište',
    Price: 'Cijena',
    Volume: 'Količina',
    'Date is not set': 'Datum nije izabran',
    'Please choose the date to fetch the data':
      'Morate izabrati datum da biste izvršili ovu pretragu.',
    'Delivery date': 'Datum isporuke',
    'Select date': 'Izaberite datum',
    'Start date': 'Početni datum',
    'End date': 'Krajnji datum',
    'Time step': 'Korak',
    Day: 'Dan',
    Week: 'Nedjelja',
    Month: 'Mjesec',
    Quarter: 'Kvartal',
    Year: 'Godina',
    'Blocks per day': 'Blokovi po danima',
    'Hourly data': 'Podaci po satima',
    'Get results': 'Prikaži podatke',
    'Timestep [h]': 'Sati [h]',
    'Volume [MWh]': 'Količina [MWh]',
    'Price [EUR/MWh]': 'Cijena [EUR/MWh]',
    'Price [€/MWh]': 'Cijena [€/MWh]',
    Hour: 'Sat',
    'Block name': 'Ime Bloka',
    'Get Excel Report': 'Preuzmi excel izvještaj',
  },
}

export const _trs = (eng) => {
  // console.log('Accessing translation', eng)
  if (
    window.locale &&
    _strings[window.locale] &&
    _strings[window.locale][eng]
  ) {
    return _strings[window.locale][eng]
  } else {
    return eng
  }
}
